<template>
    <div class="space-y-3">
        <OverlayFiltersFilterMenu :filters="filters" @update:filters="emit('update:filters', $event)" />
        <FilterChips :filters="filters" @update:filters="emit('update:filters', $event)" />
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

defineProps<{ filters: Filter[] }>()
const emit = defineEmits<{ 'update:filters': [Filter[]] }>()
</script>
